import { isServer } from './common';

export const getDeviceWidth = () => {
  if (!isServer()) {
    return window.innerWidth;
  }
};
